import { apiFetch } from '../utils/apiClient';
import { S3_SOURCES_PATH } from '../constants/apiEndpoints';

export async function fetchAccountsByContractId(contractId, page = 1, pageSize = 10) {
    if (!contractId) {
        return {
            message: '',
            accounts: [],
            count: 0,
            totalCount: 0,
            page,
            pageSize,
            totalPages: 0
        };
    }

    const queryParams = new URLSearchParams({
        contract_id: contractId,
        page: String(page),
        page_size: String(pageSize)
    });

    const response = await apiFetch(`${S3_SOURCES_PATH}?${queryParams.toString()}`, {
        method: 'GET'
    });

    return {
        message: response.message || '',
        accounts: response.sources || [],
        count: response.count || 0,
        totalCount: response.total_count || 0,
        page: response.page || page,
        pageSize: response.page_size || pageSize,
        totalPages: response.total_pages || 0
    };
}
